"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeriodNotFoundException_1 = __importDefault(require("../Exception/PeriodNotFoundException"));
class Behaviour {
    constructor(adapter, dateTimeProvider, dateTimeBridge, behaviourCache) {
        this.getDateRange = async (userId, dateRange) => {
            const sysRange = this.dateTimeBridge.systemRange(dateRange);
            return this.behaviourCache.getRange(sysRange, userId, () => this.adapter.getDateRange(userId, sysRange));
        };
        this.getDate = async (userId, date) => {
            const systemDate = this.dateTimeBridge.systemDate(date);
            const getRequest = async () => {
                const day = await this.adapter.getDate(userId, systemDate);
                return {
                    ...day,
                    date: this.dateTimeBridge.userDate(day.date),
                    day: this.dateTimeProvider.dayOfWeek(this.dateTimeBridge.userDate(day.date)),
                };
            };
            try {
                return await this.behaviourCache.getDay(date, userId, getRequest);
            }
            catch (e) {
                if (e instanceof PeriodNotFoundException_1.default) {
                    return null;
                }
                throw e;
            }
        };
        this.adapter = adapter;
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeBridge = dateTimeBridge;
        this.behaviourCache = behaviourCache;
    }
}
exports.default = Behaviour;
//# sourceMappingURL=Behaviour.js.map